import defaultPosition from "@/helpers/wc/positionSettings";

export const statisticsSettings = {
  title: "Statistics",
  name: "statisticsBase",

  styles: defaultPosition,

  properties: {
    type: 1,
    period: 1,
    targetId: 0,
    css: {
      text: {
        fontFamily: "Arial",
        fontSize: 14,
        textAlign: 'center',
        color: 'white',
        backgroundColor: 'limegreen',
        borderColor: 'grey',
        borderRadius: '5px'
      }
    }
  },
  cssLegend: {
    text: {
      name: "Text",
      fontFamily: {
        type: "fontFamily",
        name: "Font Family"
      },
      fontSize: {
        type: "int",
        name: "Font Size",
        handler: val => val + 'px'
      },
      textAlign: {
        type: "align",
        name: "Text Align"
      },
      color: {
        type: "color",
        name: "Color"
      },
      backgroundColor: {
        type: "color",
        name: "Background"
      },
      borderColor: {
        type: "color",
        name: "Border Color"
      },
      borderRadius: {
        type: "int",
        name: "Border Radius",
        handler: val => val + 'px'
      }
    }
  }
};

export const StatTypes = {
  totalVisitors: 1,
  activeVisitors: 2,
  avgVisitorTime: 3,

  historyTotalVisitors: 7,
  historyAvgTime: 8,

  queueTotalVisitors: 20,
  queueLength: 21,
  queueAvgTime: 22,
  queueCurrentVisitor: 23,
  queueNextVisitor: 24,
};

export const StatPeriod = {
  yesterday: 1,
  lastWeek: 2,
  lastMonth: 3,
};
